export default {
  labels: {
    in_store_card_payments_not_supported: '⚠️ Espèces uniquement au restaurant. Paiement par carte non accepté.',
  },
};
